import * as React from "react"

export type LoginSharedFormVariants =
	| "loginForm"
	| "forgotPasswordForm"
	| "resetPasswordForm"
	| "resetSuccessForm"

export interface LoginSharedFormContextValue {
	setActiveFormVariant: React.Dispatch<
		React.SetStateAction<LoginSharedFormVariants>
	>
	activeFormVariant: LoginSharedFormVariants
}

export const LoginSharedFormContext =
	React.createContext<LoginSharedFormContextValue>({
		setActiveFormVariant: (formVariant: LoginSharedFormVariants) => null,
		activeFormVariant: null,
	})

export interface LoginSharedFormContextProviderProps {
	defaultFormVariant: LoginSharedFormVariants
	children?: React.ReactNode
}

export const LoginSharedFormContextProvider: React.FC<LoginSharedFormContextProviderProps> =
	(props) => {
		const [activeFormVariant, setActiveFormVariant] =
			React.useState<LoginSharedFormVariants>(props.defaultFormVariant)
		return (
			<LoginSharedFormContext.Provider
				value={{
					setActiveFormVariant,
					activeFormVariant,
				}}
			>
				{props.children}
			</LoginSharedFormContext.Provider>
		)
	}
